module.exports = __webpack_public_path__ + "img/icon_book.c1b16c4b.svg";